import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import BASE_URL from "../config";

const EditClient = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id"); // Get ID from URL query string

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        contact_type: "",
        country: "",
        other_contact: "",
        email: "",
        website: "",
        payment_type: "",
        asset_type: "",
        payment_mode: "",
        domain_info: "",
        server_info: "",
        email_info: ""
    });

    // Fetch client data with payments
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (id) {
            fetch(`${BASE_URL}api/clients/find-one/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    if (data) {
                        setFormData({
                            name: data.name || "",
                            phone: data.phone || "",
                            contact_type: data.contact_type || "",
                            country: data.country || "",
                            other_contact: data.other_contact || "",
                            email: data.email || "",
                            website: data.website || "",
                            payment_type: data.payment_type || "",
                            asset_type: data.asset_type || "",
                            payment_mode: data.payment_mode || "",
                            domain_info: data.domain_info || "",
                            server_info: data.server_info || "",
                            email_info: data.email_info || ""
                        });
                    }
                })
                .catch(error => {
                    console.error("Error fetching client data:", error);
                    Swal.fire("Error", "Failed to fetch client data.", "error");
                });
        }
    }, [id]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const token = localStorage.getItem("token");
        fetch(`${BASE_URL}api/clients/update/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
            body: JSON.stringify(formData)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("Failed to update client data");
                }
                return response.json();
            })
            .then(data => {
                console.log("Updated Client Data:", data);
                Swal.fire({
                    title: "Success!",
                    text: "Client Updated Successfully!",
                    icon: "success",
                    confirmButtonText: "OK"
                }).then(() => {
                    window.location.href = "/clients"; // Redirect after success
                });
            })
            .catch(error => {
                console.error("Error updating client data:", error);
                Swal.fire({
                    title: "Error",
                    text: "Failed to update client data.",
                    icon: "error"
                });
            });
    };


    return (
        <div className="clients mt-4 mx-3">
            <h2 className="mb-3">Edit Client</h2>
            <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Client Name</label>
                        <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Phone</label>
                        <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleChange} required />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Contact Type</label>
                        <select className="form-control" name="contact_type" value={formData.contact_type} onChange={handleChange} required>
                            <option value="Whatsapp">Whatsapp</option>
                            <option value="Skype">Skype</option>
                            <option value="Email">Email</option>
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Country</label>
                        <input type="text" className="form-control" name="country" value={formData.country} onChange={handleChange} />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Other Contact</label>
                        <input type="text" className="form-control" name="other_contact" value={formData.other_contact} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Email</label>
                        <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} required />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Website</label>
                        <input type="text" className="form-control" name="website" value={formData.website} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Payment Type</label>
                        <select className="form-control" name="payment_type" value={formData.payment_type} onChange={handleChange}>
                            <option value="Monthly">Monthly</option>
                            <option value="Yearly">Yearly</option>
                            <option value="Biweekly">Biweekly</option>
                            <option value="Onetime">Onetime</option>
                        </select>
                    </div>
                </div>


                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Asset Type</label>
                        <select className="form-control" name="asset_type" value={formData.asset_type} onChange={handleChange} required>
                            <option value="">Select Asset Type</option>
                            <option value="Website Hosting">Website Hosting</option>
                            <option value="Domain">Domain</option>
                            <option value="Emails">Emails</option>
                            <option value="Others">Others</option>
                        </select>
                        <div className="invalid-feedback">Please Select a Asset Type.</div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Payment Mode</label>
                        <select className="form-control" name="payment_mode" value={formData.payment_mode} onChange={handleChange} required>
                            <option value="">Select Payment Mode</option>
                            <option value="Standard Chartered">Standard Chartered</option>
                            <option value="Payoneer">Payoneer</option>
                            <option value="JazzCash">JazzCash</option>
                            <option value="Cash">Cash</option>
                        </select>
                        <div className="invalid-feedback">Please Select a Payment Mode.</div>
                    </div>
                </div>

                <div className="mb-3">
                    <label className="form-label">Domain Info</label>
                    <textarea className="form-control" name="domain_info" value={formData.domain_info} onChange={handleChange}></textarea>
                </div>

                <div className="mb-3">
                    <label className="form-label">Server Info</label>
                    <textarea className="form-control" name="server_info" value={formData.server_info} onChange={handleChange}></textarea>
                </div>

                <div className="mb-3">
                    <label className="form-label">Email Info</label>
                    <textarea className="form-control" name="email_info" value={formData.email_info} onChange={handleChange}></textarea>
                </div>

                <button type="submit" className="btn btn-primary">Update Client</button>
                <a href="/clients" className="btn btn-secondary mx-3">Cancel</a>
            </form>
        </div>
    );
};

export default EditClient;